import { Tooltip } from '@mantine/core';
import { IconHelpCircle } from '@tabler/icons-react';

interface LabelWithTooltipProps {
  text: string;
  tooltip: string;
}

const LabelWithTooltip = ({ text, tooltip }: LabelWithTooltipProps) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <span style={{ fontWeight: 500, fontSize: '0.875rem' }}>{text}</span>
      <Tooltip label={tooltip} withArrow withinPortal>
        <IconHelpCircle size={16} color="var(--mantine-color-blue-filled)" />
      </Tooltip>
    </div>
  );
};

export { LabelWithTooltip };